module.exports = __webpack_public_path__ + "static/img/9.61937ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/sp/9.png
// module id = 9s24
// module chunks = 0